import * as plugins from '../plugins.js';
import type { IIdentity } from '../data/auth.js';

export const opsRealtimeResources = [
  'emailDomains',
  'emailQueue',
  'smtpAttempts',
  'dns',
  'routes',
  'edges',
  'certificates',
  'configEvents',
] as const;

export type TOpsRealtimeResource = (typeof opsRealtimeResources)[number];

export type IOpsRealtimeRevisionMap = Record<TOpsRealtimeResource, number>;

export interface IOpsRealtimeInvalidation {
  resource: TOpsRealtimeResource;
  revision: number;
  changedIds?: string[];
  reason?: string;
  timestamp: number;
}

/**
 * Authenticates the current WebSocket peer and returns anything newer than the
 * client's last accepted revision. The tag is assigned by the server only.
 */
export interface IReq_SubscribeOpsRealtime extends plugins.typedrequestInterfaces.implementsTR<
  plugins.typedrequestInterfaces.ITypedRequest,
  IReq_SubscribeOpsRealtime
> {
  method: 'subscribeOpsRealtime';
  request: {
    identity: IIdentity;
    knownServerEpoch?: string;
    knownRevisions?: Partial<IOpsRealtimeRevisionMap>;
  };
  response: {
    serverEpoch: string;
    revisions: IOpsRealtimeRevisionMap;
    invalidations: IOpsRealtimeInvalidation[];
  };
}

/** Server-to-browser notification. Resource data remains behind authenticated reads. */
export interface IReq_PushOpsRealtimeInvalidation extends plugins.typedrequestInterfaces.implementsTR<
  plugins.typedrequestInterfaces.ITypedRequest,
  IReq_PushOpsRealtimeInvalidation
> {
  method: 'pushOpsRealtimeInvalidation';
  request: {
    serverEpoch: string;
    invalidations: IOpsRealtimeInvalidation[];
  };
  response: Record<string, never>;
}
